// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1hZZX","modalFooterButton":"ModalNotes_modalFooterButton__3ex4n"};